import React, { useMemo } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import classnames from 'classnames';

import { CUSTOM_LABELS, ENABLE_COUNTRY } from 'static/Constants';
import CountryCode, { NMICountryCode } from 'static/CountryCode';

import './FlagCountrySelectionFieldInput.less';

const FlagCountrySelectionFieldInput = (props) => {
  const {
    value,
    className,
    defaultCountry,
    isLanguage = false,
    isNMI = false,
    ...restProps
  } = props;

  const procValue = useMemo(() => {
    if (!value) return defaultCountry || null;

    if (value && value?.length > 2) {
      const labelDefine = isNMI
        ? NMICountryCode
        : isLanguage
        ? CUSTOM_LABELS
        : CountryCode;
      return Object.keys(labelDefine).find(
        (labelKey) => labelDefine[labelKey] === value
      );
    }

    return value;
  }, [value, defaultCountry, isLanguage]);

  const countryConfig = isNMI
    ? { countries: Object.keys(NMICountryCode) }
    : isLanguage
    ? {
        countries: ENABLE_COUNTRY,
        customLabels: CUSTOM_LABELS,
      }
    : {};

  return (
    <ReactFlagsSelect
      className={classnames('flag-country-selection-field-input', className)}
      selected={procValue}
      {...countryConfig}
      {...restProps}
    />
  );
};

export default FlagCountrySelectionFieldInput;
